import { gsap } from 'gsap';
import { SplitText } from 'gsap/SplitText';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger, SplitText);

const eyebrowModule = () => {

    const eyebrows = document.querySelectorAll('.js-eyebrow');

    eyebrows.forEach(eyebrow => {

        const eyebrowBackground = eyebrow.querySelector('.js-eyebrow-background');
        const eyebrowText = eyebrow.querySelector('.js-eyebrow-text');

        ScrollTrigger.matchMedia({
            "(pointer: fine)": () => {

                const tl = gsap.timeline({
                    delay: 0.5,
                    scrollTrigger: {
                        trigger: eyebrow,
                        start: 'top 90%',
                    },
                });

                tl.to(eyebrowBackground, {
                    clipPath: 'polygon(0 0, 100% 0, 100% 100%, 0 100%)',
                    duration: 0.5,
                    ease: 'power3.inOut',
                }, 0)
                .to(eyebrowBackground, {
                    clipPath: 'polygon(100% 0, 100% 0, 100% 100%, 100% 100%)',
                    duration: 0.5,
                    ease: 'power3.inOut',
                }, 0.4)
                .to(eyebrowText, {
                    clipPath: 'polygon(0 0, 100% 0, 100% 100%, 0 100%)',
                    duration: 0.5,
                    filter: 'blur(0px)',
                    ease: 'power3.inOut',
                }, 0.4);

            },
            "(pointer: coarse)": () => {

                gsap.set(eyebrowBackground, {
                    clipPath: 'polygon(0 0, 100% 0, 100% 100%, 0 100%)',
                    opacity: 0
                });

                gsap.set(eyebrowText, {
                    clipPath: 'polygon(0 0, 100% 0, 100% 100%, 0 100%)',
                    filter: 'blur(0px)',
                });

            }
        });

    });

}

export { eyebrowModule };